import { render, staticRenderFns } from "./evolution.vue?vue&type=template&id=0365c837&scoped=true&"
import script from "./evolution.vue?vue&type=script&lang=js&"
export * from "./evolution.vue?vue&type=script&lang=js&"
import style0 from "./evolution.vue?vue&type=style&index=0&id=0365c837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365c837",
  null
  
)

export default component.exports